"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureExpProjectsWithPaginationSchema = exports.FeatureExpProjectPatchSchema = exports.FeatureExpProjectCreationSchema = exports.FeatureExpProjectSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
exports.FeatureExpProjectSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable().optional(),
    emoji: zod_1.z.string().nullable().optional(),
    created_by_user: zod_1.z
        .object({
        id: zod_1.z.string(),
        email: zod_1.z.string(),
        firstName: zod_1.z.string(),
        lastName: zod_1.z.string(),
    })
        .nullable(),
});
exports.FeatureExpProjectCreationSchema = exports.FeatureExpProjectSchema.omit({ id: true }).partial({
    created_by_user: true,
});
exports.FeatureExpProjectPatchSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    accountEnvironmentId: zod_1.z.string(),
    payload: exports.FeatureExpProjectSchema.omit({ created_by_user: true }),
});
exports.FeatureExpProjectsWithPaginationSchema = schemas_1.FeatureExpPaginationSchema.extend({
    items: zod_1.z.array(exports.FeatureExpProjectSchema),
});
//# sourceMappingURL=schemas.js.map